import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'

const LoadingComponent = () => {
    const useLoadingStyles = makeStyles(() => ({
        root: {
            fontStyle: 'normal',
            lineHeight: '19.07px',
            color: '#989898',
            margin: '0',
            height:'2.625rem !important',
            display:'flex',
            alignContent:'center',
            justifyContent:'flex-start',
            alignItems:'center',
            '& span': {
                fontWeight: '600',
                fontSize: '14px',
            }
        },
        disabled: {
            opacity: '1 !important'
        }
    }))

    const classes = useLoadingStyles()

    return (
        <MenuItem className={classes.disabled} disabled>
            <ListItemText
                className={classes.root}
                primary={'Loading...'}
            />
        </MenuItem>
    )
}

export default LoadingComponent
